import {orderListAdditionalListProps, OrderListExtendedModel, OrdersList} from '@views/orders/OrdersList';
import app from '@src/helpers/app';
import {ListViewProps} from '@src/components/_views/configurable/ListView';
import {ListProps} from '@src/@types/components/List';

const tableHeadProps: typeof orderListAdditionalListProps['head'] = {
    ...orderListAdditionalListProps['head'],
    preferenceNameMutator: (name: string) => `clients.${name}`,
};

class ClientOrdersList extends OrdersList<{
    clientId: number | string,
}> {
    protected getPropsForListComponent(): Partial<NonNullable<ListViewProps<OrderListExtendedModel>['listProps']>> {
        const url = app('url')
                .getRouteByName('clients.get-orders')
                .resolveUrl({id: this.props.clientId});

        return {
            getListRequestUrl: url,
            recordsProviderAdditionalShapeProps: {is: 'orders-list'},
            withoutControlsRow: true,
            withoutFilters: true,
        };
    }

    protected getPropsForTableHeadComponent(): ListProps['tableHeadProps'] {
        return tableHeadProps;
    }
}

export default ClientOrdersList.getStoreConnector()(ClientOrdersList);
